import { tv } from '~/utils/tv'

export const ToastDescriptionVariants = tv({
  base: `
  text-text-neutral !font-rdmodern font-regular  text-threeandhalfpulse
  leading-small truncate
  `,
  variants: {},
})
